var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"About Cairns Property Rentals"}}),_c('div',[_c('ContentRow',[_c('ContentContainer',[_c('RichText',{staticClass:"about",attrs:{"content":_vm.office.About}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }